import { useLanguage } from '@/contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => setLanguage('en')}
        className={`text-xl leading-none px-1 py-0.5 rounded transition-all duration-200 ${
          language === 'en'
            ? 'ring-2 ring-gold scale-110'
            : 'opacity-60 hover:opacity-100 hover:scale-105'
        }`}
        aria-label="Switch to English"
      >
        🇬🇧
      </button>
      <button
        onClick={() => setLanguage('bg')}
        className={`text-xl leading-none px-1 py-0.5 rounded transition-all duration-200 ${
          language === 'bg'
            ? 'ring-2 ring-gold scale-110'
            : 'opacity-60 hover:opacity-100 hover:scale-105'
        }`}
        aria-label="Превключи на български"
      >
        🇧🇬
      </button>
    </div>
  );
};

export default LanguageSwitcher;
